<template>
  <div id="paypal-button"></div>
</template>

<script>
export default {

  data(){
    return {
      paypalCreds: {
        sandbox: 'AeWpiGfJKa9phA6rBnIEFaQyRIQvgkUpvjn2Wv4vGCABXKjSgifOKdnswwEjhi-i65iSsufCSRHABVdW',
        production: '123'
      },
    }
  },
  mounted(){
    paypal.Button.render({
      env: 'sandbox',
      client: this.paypalCreds,
      commit: true,
      payment: this.setupPayment,
      onAuthorize: this.doPayment,
    }, '#paypal-button');
  },
  methods: {
    setupPayment(data, actions){
      return actions.payment.create({
        payment: {
          transactions: [
            { amount: { total: '15.00', currency: 'AUD'} }
          ]
        }
      });
    },
    doPayment(data, actions){
      return actions.payment.execute().then((payment)=>{
        this.$emit('confirm', payment);
      })
    }
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// PayPalCheckout.vue?5fa170d0